<template>
  <TransitionRoot as="template" :show="show">
    <Dialog class="relative z-50" @close="closeModal">
      <TransitionChild as="template" enter="ease-out duration-100" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500/75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-50 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-100"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white dark:bg-gray-800 px-4 pb-4 pt-5 text-left shadow-xl transition-all"
              :class="modalClass">
              <div v-if="!preventBackdropClose" class="absolute right-0 top-0 pr-4 pt-4">
                <button type="button"
                  class="rounded-md bg-white dark:bg-gray-600 text-gray-400 hover:text-gray-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-gray-800 transition-colors duration-200"
                  @click="closeModal" aria-label="Close modal">
                  <span class="sr-only">Close</span>
                  <XMarkIcon class="size-6" aria-hidden="true" />
                </button>
              </div>
              <div class="sm:flex sm:items-start">
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left w-full">
                  <DialogTitle as="h3" class="text-base font-semibold text-gray-900 dark:text-gray-300">
                    <slot name="header"></slot>
                  </DialogTitle>
                  <div class="mt-2 w-full">
                    <slot name="body"></slot>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-4 sm:flex justify-end flex">
                <slot name="footer"></slot>
                <!-- <button
                    type="button"
                    class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                    @click="show = false"
                  >
                    Deactivate
                  </button>
                  <button
                    type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    @click="show = false"
                  >
                    Cancel
                  </button> -->
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import { computed } from "vue";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { XMarkIcon } from "@heroicons/vue/24/outline";

const props = defineProps<{
  show: boolean;
  modalSize?: string;
  /** 是否阻止点击背景和按 ESC 关闭弹窗 */
  preventBackdropClose?: boolean;
}>();
const modalClass = computed(
  () => props.modalSize || "sm:my-8 sm:w-full sm:max-w-xl sm:p-6"
);

const emit = defineEmits<{
  (e: "close"): void;
}>();
const closeModal = () => {
  // 如果设置了 preventBackdropClose，则不触发 close 事件
  if (props.preventBackdropClose) {
    return;
  }
  emit("close");
};

defineExpose({ show: props.show });
</script>
